<script>
  import Keno from './Keno'
  import KenoClassic from './KenoClassic'
  import Roulette from './Roulette'
  import Baccarat from './Baccarat'
  import HiloLocal from './HiloLocal'
  import HiloHitech from './HiloHitech'
  import DragonTiger from './DragonTiger'
  const routes = {
    'keno': Keno,
    'keno_classic': KenoClassic,
    'roulette': Roulette,
    'baccarat': Baccarat,
    'hilo_local': HiloLocal,
    'hilo_hitech': HiloHitech,
    'dragon_tiger': DragonTiger,
    'baccarat_insurance': Baccarat,
  }
  export default {
    name: 'game-table',
    props: {
      user: {
        required: true,
        type: Object
      },
      kind: {
        required: true,
        type: String
      },
      tableId: {
        required: true,
        type: [Number, String]
      },
    },
    computed: {
      viewComponent () {
        return routes[this.kind.toLowerCase()]
      }
    },
    mounted () {
      //
    },
    render (h) {
      return h(this.viewComponent, {
        props: {
          user: this.user,
          kind: this.kind,
          tableId: this.tableId
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/GameTable.vue